import script from "./GlobalAssistantPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAssistantPanel.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAssistantPanel.vue?vue&type=style&index=0&id=0e864e05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e864e05"]])

export default __exports__